type KeyElement = { _key: string };

export default function findInKeyArray<V extends KeyElement>(
  value: V[],
  values: string[]
) {
  for (const val of values) {
    const found = value.find(({ _key }) => _key === val);
    if (found) return found;
  }

  return null;
}
